// src/services/accountService.js
// All Supabase operations for accounts table

import { supabase } from '../lib/supabase'

/**
 * Fetch all accounts for the current user
 */
export async function fetchAccounts() {
  const { data, error } = await supabase
    .from('accounts')
    .select('*')
    .order('created_at', { ascending: true })

  if (error) return { data: [], error: error.message }
  return { data, error: null }
}

/**
 * Create a new account
 */
export async function createAccount({ name, type, balance, color }) {
  const { data: { user } } = await supabase.auth.getUser()
  if (!user) return { data: null, error: 'Not authenticated' }

  const { data, error } = await supabase
    .from('accounts')
    .insert({
      user_id: user.id,
      name,
      type,
      balance: parseFloat(balance) || 0,
      color,
    })
    .select()
    .single()

  if (error) return { data: null, error: error.message }
  return { data, error: null }
}

/**
 * Update an existing account
 */
export async function updateAccount(id, updates) {
  const { data, error } = await supabase
    .from('accounts')
    .update({
      name:    updates.name,
      type:    updates.type,
      balance: parseFloat(updates.balance) || 0,
      color:   updates.color,
    })
    .eq('id', id)
    .select()
    .single()

  if (error) return { data: null, error: error.message }
  return { data, error: null }
}

/**
 * Update just the balance of an account (used after transaction CRUD)
 */
export async function updateAccountBalance(id, newBalance) {
  const { data, error } = await supabase
    .from('accounts')
    .update({ balance: parseFloat(newBalance.toFixed(2)) })
    .eq('id', id)
    .select('id, balance')
    .single()

  if (error) return { data: null, error: error.message }
  return { data, error: null }
}

/**
 * Delete an account
 */
export async function deleteAccount(id) {
  const { error } = await supabase
    .from('accounts')
    .delete()
    .eq('id', id)

  if (error) return { error: error.message }
  return { error: null }
}

/**
 * Get a single account by id
 */
export async function getAccount(id) {
  const { data, error } = await supabase
    .from('accounts')
    .select('*')
    .eq('id', id)
    .single()

  if (error) return { data: null, error: error.message }
  return { data, error: null }
}
